import Vue from 'vue';
import VueRouter from 'vue-router';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import { name, version } from '../package.json'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'main',
    meta: {layout: 'main' },
    component: () => import('./views/Main.vue')
  },
  {
    path: '/bot/:id',
    name: 'bot',
    meta: {layout: 'bot' },
    component: () => import('./views/Bot.vue')
  },
  {
    path: '/bot/:id/stats',
    name: 'botStats',
    meta: {layout: 'nosidebar' },
    component: () => import('./views/BotStats.vue')
  },
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/404',
    name: '404',
    meta: {layout: 'main'},
    component: () => import('./views/404.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

Sentry.init({
  Vue,
  // cannot be moved to .env
  dsn: "https://0dc9ceba9b724b93b297c216f429b22e@sentry.supportyourapp.com/5",
  environment: process.env.NODE_ENV,
  release: `${name}@${version}`,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      // tracingOrigins: ["localhost", "my-site-url.com", /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

export default router;
